import { Injectable } from '@angular/core';
import { Confirmation, ConfirmationService } from 'primeng/api';

/** Staging defaults for ConfirmDialog (v14 showed check / times on buttons). */
const DEFAULT_ACCEPT_ICON = 'pi pi-check';
const DEFAULT_REJECT_ICON = 'pi pi-times';

@Injectable()
export class XiroccoConfirmationService extends ConfirmationService {
  override confirm(confirmation: Confirmation) {
    return super.confirm({
      ...confirmation,
      acceptIcon: confirmation.acceptIcon ?? DEFAULT_ACCEPT_ICON,
      rejectIcon: confirmation.rejectIcon ?? DEFAULT_REJECT_ICON
    });
  }
}
